import { useAppContext } from '@/context';
import { logout } from '@/utils/auth';
import { getJson } from '@/utils/fetchOptions';

import { useAuthToken, useQuery } from '..';

interface useScreenshotsProps {
  id: string;
  beat_id: string;
  step?: string;
}

export function useScreenshots({ id, beat_id, step }: useScreenshotsProps) {
  const { setAlert } = useAppContext();
  const token = useAuthToken();

  const { data, error, isLoading, refetch, isRefetching } = useQuery({
    queryKey: `influencer-screenshots-${id}-${beat_id}-${step}`,
    queryFn: async () =>
      getJson({
        url: `${process.env.NEXT_PUBLIC_BEATLY_API_URL}/app/v2/influencer/collaboration/${id}/screenshots/requests?beat_id=${beat_id}&step=${step}`,
        token
      }).then((response: { requests: Api.Influencer.Screenshot[] } | ResponseObject) => {
        if ((response as ResponseExpiredToken).isExpired) {
          logout();
        }

        if ('code' in response) {
          setAlert(response.code);
        }

        return response;
      })
    // enabled: !!token
  });

  return {
    error,
    isLoading,
    refetch,
    screenshots: data?.requests || [],
    isRefetching
  };
}
